import { useEffect, useState, forwardRef } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import { useNavigate, Link } from 'react-router-dom';

// material-ui
import {
    Grid,
    Typography,
    Box,
    Card,
    CardContent,
    IconButton,
    Avatar,
    Button,
    // Link,
    Dialog,
    Slide,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    TextField,
    AvatarGroup
} from '@mui/material';

import { SelectInput } from '../libs/formik_fields/SelectField';

import { styled } from '@mui/material/styles';
import Breadcrumb from 'components/ui/Breadcrumb';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionSummary, { AccordionSummaryProps } from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import { LoadingButton } from '@mui/lab';
import CloseIcon from '@mui/icons-material/Close';

import { gridSpacing } from 'store/constant';
import DashboardCard from '../components/dashboard/DashboardCard';
import { IconBuilding, IconBook, IconQuestionMark, IconUsers } from '@tabler/icons';
import { getDashboardDataRequest } from '../services/dashboard';
import TestimonialForm from 'components/testimonial/TestimonialForm';
import { addTestimonialRequest, deleteTestimonialRequest, getTestimonialRequest, orderTestimonialRequest } from 'services/testimonial';
import { extractValue } from '../utils';
import appUrls from 'appUrls';
import TestimonialModal from 'components/testimonial/TestimonialModal';
import {
    selectUserLevel,
    selectUserYearBookLastDate,
    selectUserYearIsFreezeTestimonials,
    selectUserYearIsSequenceTestimonials
} from 'store/slices/authSlice';
import { useSelector } from 'react-redux';
import moment from 'moment';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2)
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1)
    }
}));

const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500]
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

const Accordion = styled((props) => <MuiAccordion disableGutters elevation={0} square {...props} />)(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    margin: '10px 0',
    '&:before': {
        display: 'none'
    }
}));

const AccordionSummary = styled((props) => <MuiAccordionSummary {...props} />)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, .05)' : 'rgba(0, 0, 0, .03)',

    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)'
    },
    '& .MuiAccordionSummary-content': {
        margin: '0 6px'
    }
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)'
}));

// ==============================|| DEFAULT DASHBOARD ||============================== //

const Dashboard = () => {
    const [isLoading, setLoading] = useState(true);
    const [testimonialData, setTestimonialData] = useState({});
    const [expandedSent, setExpandedSent] = useState(null);
    const [expandedReceived, setExpandedReceived] = useState(null);
    const [initialValues, setInitialValues] = useState({});
    const [open, setOpen] = useState(false);

    const IsFreezeTestimonials = useSelector(selectUserYearIsFreezeTestimonials);
    const UserLevel = useSelector(selectUserLevel);

    const isSequenceTestimonial = useSelector(selectUserYearIsSequenceTestimonials);
    const yearBookLastDate = useSelector(selectUserYearBookLastDate);

    const isLastDateSmaller = moment(yearBookLastDate).isSameOrBefore(new Date());

    // const handleOpen = () => setOpen(true);
    // const handleClose = () => setOpen(false);
    const navigate = useNavigate();

    const handleChangeSent = (panel) => (event, newExpanded) => {
        setExpandedSent(newExpanded ? panel : false);
    };

    const handleChangeReceived = (panel) => (event, newExpanded) => {
        setExpandedReceived(newExpanded ? panel : false);
    };

    const handleSubmitTestimonial = async (values, { resetForm, setSubmitting }) => {
        setSubmitting(true);
        const payload = {
            studentCommentTo: extractValue(values.student, '_id'),
            comment: values.comment
        };

        console.log(payload, 'payload');
        const response = await addTestimonialRequest(payload);
        // console.log('-> response', response);
        if (response.error === false) {
            resetForm();
            navigate(appUrls.TESTIMONIAL);
            setOpen(false);
        }
        setSubmitting(false);
    };

    const defaultList = [
        {
            id: '1',
            name: 'Sushil Singh',
            comment: 'Hello Team Designers!',
            image: 'https://the-forever-diary.s3.us-east-2.amazonaws.com/uploads/year_book_13/users/2330_Sushil/thumb/1627716264_sushil.designer@theforeverdiary.com.jpeg'
        },
        {
            id: '2',
            name: 'Abhishek',
            comment: 'Hello Team Designers!',
            image: 'https://the-forever-diary.s3.us-east-2.amazonaws.com/uploads/year_book_13/users/2330_Sushil/thumb/1627716264_sushil.designer@theforeverdiary.com.jpeg'
        },
        {
            id: '3',
            name: 'Abhishek',
            comment: 'Hello Team Designers!',
            image: 'https://the-forever-diary.s3.us-east-2.amazonaws.com/uploads/year_book_13/users/2330_Sushil/thumb/1627716264_sushil.designer@theforeverdiary.com.jpeg'
        }
    ];
    // React state to track order of items
    const [itemList, setItemList] = useState(defaultList);

    // Function to update list on drop
    const handleDrop = async (droppedItem) => {
        console.log(droppedItem, 'droppedItem');
        const updatedList = [...testimonialData.receiveTestimonials];
        // Ignore drop outside droppable container
        if (!droppedItem.destination) return;

        // Remove dragged item
        const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
        // console.log(reorderedItem, 'reorderedItem');
        // Add dropped item
        updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
        const apiData = [];
        const result = updatedList.map((item, index) => {
            apiData.push({ tOrder: index + 1, _id: item._id });
            return { ...item, tOrder: index + 1 };
        });

        // Update State
        setTestimonialData({ ...testimonialData, receiveTestimonials: result });
        await orderTestimonialRequest(apiData);
    };

    async function fetchData() {
        setLoading(true);
        const data = await getTestimonialRequest();
        setLoading(false);
        if (data.error === false) {
            setTestimonialData(data);
        }
    }

    useEffect(() => {
        fetchData();
    }, []);

    const handleDeleteTestimonial = async (testimonialId) => {
        const result = await deleteTestimonialRequest(testimonialId);
        if (result.error === false) {
            fetchData();
        }
    };

    return (
        <>
            <Breadcrumb
                title="Testimonial"
                button={() =>
                    UserLevel === '2' ? null : (
                        <Box width="100%" display="flex" justifyContent="flex-end" alignItems="flex-end">
                            <Button component={Link} to={'/request-testimonial'}>
                                {testimonialData.receiveRequestTestimonialsCount} Request Testimonial
                            </Button>
                        </Box>
                    )
                }
            />

            <Grid container spacing={gridSpacing}>
                <Grid item xs={12}>
                    <Grid container spacing={gridSpacing}>
                        {isLastDateSmaller ? null : (
                            <Grid item lg={6} md={6} sm={6} xs={12}>
                                <Card>
                                    <CardContent>
                                        <Grid container>
                                            <Grid item xs={12}>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <Typography variant="h1">
                                                        {testimonialData && testimonialData.sentTestimonials?.length}
                                                    </Typography>{' '}
                                                    <Button
                                                        onClick={() => {
                                                            setInitialValues({
                                                                student: null,
                                                                comment: ''
                                                            });
                                                            setOpen(true);
                                                        }}
                                                    >
                                                        Add
                                                    </Button>
                                                    {/* <Link
                                                    onClick={() => {
                                                        setInitialValues({
                                                            student: null,
                                                            comment: ''
                                                        });
                                                        setOpen(true);
                                                    }}
                                                    align="right"
                                                    width="50%"
                                                    href="#"
                                                    underline="none"
                                                >
                                                    Add
                                                </Link> */}
                                                </Box>

                                                <Typography variant="h4" mb={1}>
                                                    Sent Testimonial
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12}>
                                                {testimonialData?.sentTestimonials?.map((item, index) => (
                                                    <Accordion expanded={expandedSent === item._id} onChange={handleChangeSent(item._id)}>
                                                        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                                                            <Avatar
                                                                alt={item.studentCommentTo.name}
                                                                src={
                                                                    item.studentCommentTo.image
                                                                        ? `${testimonialData.imageBaseUrl}${item.studentCommentTo.image}`
                                                                        : ''
                                                                }
                                                                sx={{ width: 30, height: 30 }}
                                                            />
                                                            <Typography
                                                                style={{ textTransform: 'uppercase', color: 'black' }}
                                                                margin="auto 10px"
                                                            >
                                                                Sent to {item.studentCommentTo.name}
                                                            </Typography>
                                                        </AccordionSummary>
                                                        <AccordionDetails>
                                                            <Typography>{item.comment}</Typography>
                                                            <Button
                                                                onClick={() => {
                                                                    setInitialValues({
                                                                        student: item.studentCommentTo,
                                                                        comment: item.comment
                                                                    });
                                                                    setOpen(true);
                                                                }}
                                                            >
                                                                Edit
                                                            </Button>
                                                            <Button color="error" onClick={() => handleDeleteTestimonial(item._id)}>
                                                                Delete
                                                            </Button>
                                                        </AccordionDetails>
                                                    </Accordion>
                                                ))}
                                                {/* {JSON.stringify(initialValues)} */}
                                                {/* <GalleryAddImageForm handleSubmit={handleAddImageSubmit} /> */}
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                        )}
                        {UserLevel === '2' || IsFreezeTestimonials ? null : (
                            <Grid item lg={6} md={6} sm={6} xs={12}>
                                <Card>
                                    <CardContent>
                                        <Grid container>
                                            <Grid item xs={12}>
                                                <Typography align="right" variant="h1">
                                                    {testimonialData && testimonialData.receiveTestimonials?.length}
                                                </Typography>
                                                <Typography align="right" variant="h4" mb={1}>
                                                    Received Testimonial
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <DragDropContext onDragEnd={handleDrop}>
                                                    <Droppable droppableId="list-container">
                                                        {(provided) => (
                                                            <div
                                                                className="list-container"
                                                                {...provided.droppableProps}
                                                                ref={provided.innerRef}
                                                            >
                                                                {testimonialData?.receiveTestimonials?.map((item, index) => (
                                                                    <Draggable key={item._id} draggableId={item._id} index={index}>
                                                                        {(provided) => (
                                                                            <div
                                                                                className="item-container"
                                                                                ref={provided.innerRef}
                                                                                {...provided.dragHandleProps}
                                                                                {...provided.draggableProps}
                                                                            >
                                                                                <Accordion
                                                                                    expanded={expandedReceived === item._id}
                                                                                    onChange={handleChangeReceived(item._id)}
                                                                                >
                                                                                    <AccordionSummary
                                                                                        aria-controls="panel1d-content"
                                                                                        id="panel1d-header"
                                                                                    >
                                                                                        <Typography
                                                                                            width="100%"
                                                                                            align="right"
                                                                                            margin="auto 10px"
                                                                                            style={{
                                                                                                textTransform: 'uppercase',
                                                                                                color: 'black'
                                                                                            }}
                                                                                        >
                                                                                            Received from {item.studentCommentBy.name}
                                                                                        </Typography>
                                                                                        <Avatar
                                                                                            alt={item.studentCommentBy.name}
                                                                                            src={
                                                                                                item.studentCommentBy.image
                                                                                                    ? `${testimonialData.imageBaseUrl}${item.studentCommentBy.image}`
                                                                                                    : ''
                                                                                            }
                                                                                            sx={{ width: 30, height: 30 }}
                                                                                        />
                                                                                    </AccordionSummary>
                                                                                    <AccordionDetails>
                                                                                        <Typography>{item.comment}</Typography>
                                                                                        <Button
                                                                                            color="error"
                                                                                            onClick={() =>
                                                                                                handleDeleteTestimonial(item._id)
                                                                                            }
                                                                                        >
                                                                                            Delete
                                                                                        </Button>
                                                                                    </AccordionDetails>
                                                                                </Accordion>
                                                                            </div>
                                                                        )}
                                                                    </Draggable>
                                                                ))}
                                                                {provided.placeholder}
                                                            </div>
                                                        )}
                                                    </Droppable>
                                                </DragDropContext>
                                                {/* <GalleryAddImageForm handleSubmit={handleAddImageSubmit} /> */}
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                        )}
                        <TestimonialModal initialValues={initialValues} open={open} setOpen={setOpen} fetchData={() => fetchData()} />
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
};

export default Dashboard;
